<template>
  <li class="store_item">
    <router-link
      :to="'/supermarket/shop_detail?id=' + item.id + '&shop_id=' +( item.institute||item.instituteId)"
      target="_blank"
    >
      <hotLabels v-if="item.is_coupon" style="position: absolute;right: 20px;top: 20px"></hotLabels>
      <img v-lazy="item.coverPath" :key="item.coverPath" class="store_item_img" />
      <h3>{{item.name}}</h3>
      <template v-if="item.keyword && item.keyword.indexOf('|')>-1">
        <div class="lab">
          <template v-for="keyword,i in item.keyword.split('|')" v-if="keyword && i < 2">
            {{keyword}}
            <span v-if="i===0">|</span>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="lab">{{item.keyword}}</div>
      </template>

      <h4>￥{{item.price_char||'0'}}</h4>
    </router-link>
  </li>
</template>

<script>
import hotLabels from "@/components/mall/hot_labels.vue";
export default {
  components: { hotLabels },
  props: {
    item: {
      type: Object
    },
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.store_item {
  width: 390px;
  height: 228px;
  box-shadow: 0px 0px 20px 0px rgba(205, 208, 215, 0.4);
  margin: 0 15px 15px 0;
  background: #fff;
  a {
    display: flex;
    flex-direction: column;
    padding: 20px;
    position: relative;
    .store_item_img {
      width: 90px;
      height: 90px;
      border-radius: 4px;
      object-fit: cover;
      object-position: center;
    }
    h3 {
      font-size: 16px;
      color: #4c5062;
      margin-top: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    h4 {
      font-size: 16px;
      font-weight: bold;
      color: #ff743c;
      margin-top: 23px;
    }
    .lab {
      font-size: 14px;
      color: #a4a8ba;
      margin-top: 16px;
      display: flex;
      span {
        color: #dedede;
        padding: 0 10px;
      }
    }
  }
}
</style>